import * as React from 'react';
import { useCommunityQuestionLink } from '../../../../../hooks/useCommunityQuestionLink';
import { TabContentContainer } from '../../../AppListing.styles';
import { SupportResourcesLink } from '../types';
import { Columns, LeftColumn, RightColumn } from './styles';
import { SupportContact } from './SupportContact';
import { SupportResources } from './SupportResources';
import { SupportTagline } from './SupportTagline';
export const SupportTab = props => {
  const {
    supportDetails,
    atlassianCommunityBaseUrl,
    mpacBaseUrl,
    hosting,
    appKey,
    onSupportLinkClick,
    cloudMigrationInfo,
    onCloudMigrationResourceLinksClick
  } = props;
  const atlassianCommunityUrl = useCommunityQuestionLink({
    atlassianCommunityBaseUrl,
    mpacBaseUrl,
    appKey,
    hosting
  });
  const hasContact = supportDetails.isSupported && (supportDetails.availability || supportDetails.contact.emailId || supportDetails.contact.phoneNumber || supportDetails.contact.issueTrackerUrl || supportDetails.contact.supportTicketSystemUrl);
  return /*#__PURE__*/React.createElement(TabContentContainer, null, /*#__PURE__*/React.createElement(SupportTagline, {
    supportDetails: supportDetails,
    atlassianCommunityUrl: atlassianCommunityUrl.url,
    onCommunityLinkClick: () => onSupportLinkClick(SupportResourcesLink.ATLASSIAN_COMMUNITY)
  }), /*#__PURE__*/React.createElement(Columns, null, hasContact && /*#__PURE__*/React.createElement(LeftColumn, null, /*#__PURE__*/React.createElement(SupportContact, {
    supportDetails: supportDetails,
    onSupportLinkClick: onSupportLinkClick
  })), /*#__PURE__*/React.createElement(RightColumn, null, /*#__PURE__*/React.createElement(SupportResources, {
    supportDetails: supportDetails,
    onSupportLinkClick: onSupportLinkClick,
    atlassianCommunityUrl: atlassianCommunityUrl.url,
    cloudMigrationInfo: cloudMigrationInfo,
    onCloudMigrationResourceLinksClick: onCloudMigrationResourceLinksClick
  }))));
};